import React from 'react';
import HomePageExplore from "./Components/Explore";
import HomePageFooter from "./Components/Footer";
import HomePageMistakes from "./Components/Mistakes";
import HomePageTitle from "./Components/Title";

const DashboardHome = ()=> { 
  
    return (
      <div className="dashboard-home mb-5">
          <div className="container mb-5">
            <div className="row">
              <div className="col-md-12">
                <h2>Home Page</h2>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-5">
                <HomePageTitle/>
              </div>
              <div className="col-md-1"></div>
              <div className="col-md-5">
                <HomePageExplore/>
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-md-5">
                <HomePageMistakes/>
              </div>
              <div className="col-md-1"></div>
              <div className="col-md-5">
                <HomePageFooter/>
              </div>
            </div>

          </div>
      </div>
    );
  }
  
  export default DashboardHome; 